"use client";

import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { LoyaltySoftGate as LoyaltySoftGateUI } from "@jti/ui/components/LoyaltySoftGate";

import { useDisplayModelComponent } from "@/libs/builder/hooks/useDisplayModelComponent";

import type { loyaltySoftGateInputs } from "./LoyaltySoftGate.builder";

type LoyaltySoftGateProps = BuilderComponentProps<typeof loyaltySoftGateInputs>;

export const LoyaltySoftGate: FC<PropsWithChildren<LoyaltySoftGateProps>> = ({
  logoSrc,
  title,
  okBtnTitle,
  noBtnTitle,
  noBtnLink,
}) => {
  const shouldDisplayModelComponent = useDisplayModelComponent("loyalty-soft-gate");

  if (!shouldDisplayModelComponent) {
    return null;
  }

  return (
    <LoyaltySoftGateUI
      logoSrc={logoSrc}
      title={title}
      okBtnTitle={okBtnTitle}
      noBtnTitle={noBtnTitle}
      noBtnLink={noBtnLink}
      isAuthorMode={isEditing()}
    />
  );
};
